import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChildren,
  WritableSignal
} from '@angular/core';

import { SortItemsType } from '@shared/interfaces/list-fields.interface';

@Component({
  selector: 'header-list',
  templateUrl: './header-list.component.html',
  styleUrls: ['./header-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderListComponent implements AfterViewInit {
  @Input() sortItems: Array<any>;
  @Input() activeSortType = '';
  @Input() activeSortValue = '';
  @Input() listElem: ElementRef;
  @Input() stickyOptions: boolean = false;
  @Input() threeColumnsWidth: WritableSignal<string>;
  @Output() clickSortItem = new EventEmitter<string>();
  @Output() fieldsChanged = new EventEmitter<string>();

  @ViewChildren('resizable') resizable: QueryList<any>;
  @ViewChildren('column') columnItems: QueryList<ElementRef>;
  changeWidth(width, field) {
    if (field.hasOwnProperty('styles')) {
      if (width && field.styles.flex) {
        field.styles.flex = 0;

        this.sortItems.forEach((item) => {
          if (item?.isResizable && item?.styles?.flex) {
            const resizableItem = this.resizable.toArray().find((resizeItem) => resizeItem?.key === item.key);
            const newWidth = resizableItem?.box?.nativeElement?.getBoundingClientRect()?.width;
            item.styles.width = newWidth;
            item.styles.flex = 0;
          }
        });
      }
      field.styles.width = width;
    } else {
      field['styles'] = {
        width
      };
    }

    this.fieldsChanged.emit();
  }

  setActiveSort(item: SortItemsType, e: Event): void {
    e.stopPropagation();
    e.preventDefault();

    if (!Object.prototype.hasOwnProperty.call(item, 'sortType')) {
      return;
    }
    // set value if empty string or if you change the tab
    if (!this.activeSortType || !this.checkIfActive(item)) {
      this.activeSortType = item.sortType;
      this.activeSortValue = item.positiveSort;
    } else {
      if (this.activeSortValue === item.negativeSort) {
        this.activeSortValue = '';
      } else {
        this.activeSortValue = item.negativeSort;
      }
    }

    this.clickSortItem.next(this.activeSortValue);
  }

  checkIfActive(item: SortItemsType): boolean {
    if (!Object.prototype.hasOwnProperty.call(item, 'sortType')) {
      return;
    }
    return this.activeSortType === item.sortType || this.activeSortType === `-${item.sortType}`;
  }

  checkIfNegativeState(item: SortItemsType): boolean {
    return this.activeSortValue === item.negativeSort;
  }

  getIconClass(item): string {
    if (this.checkIfActive(item)) {
      return 'sort-icon-active';
    }

    return 'sort-icon';
  }

  ngAfterViewInit(): void {
    this.calculateTotalWidth();
  }

  calculateTotalWidth(): void {
    let totalWidth: number = 0;
    const indicesToInclude: number[] = [1, 2, 3];
    this.columnItems.forEach((item, index) => {
      if (indicesToInclude.includes(index)) {
        const width = item.nativeElement.clientWidth;
        totalWidth += width;
      }
    });

    if (this.threeColumnsWidth) {
      this.threeColumnsWidth.set(`${totalWidth}px`);
    }
  }
}
